import WebcoreService from './webcoreService';

export default new WebcoreService();
